import { render, staticRenderFns } from "./Theme4GalleryComponent.vue?vue&type=template&id=7085563c&scoped=true&"
import script from "./Theme4GalleryComponent.vue?vue&type=script&lang=js&"
export * from "./Theme4GalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./Theme4GalleryComponent.vue?vue&type=style&index=0&id=7085563c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7085563c",
  null
  
)

export default component.exports